import React from 'react'

import { useQuery } from '@apollo/client/react/hooks/useQuery'

import { GET_CURRENT_CUSTOMER_GIFT_CARDS } from 'Const'

import { QueryState } from '../../components/QueryState'

import { GiftCardTile } from './Card'
import { GiftCard } from './type'

export const GiftCards: React.FC = () => {
  const { data, loading, error } = useQuery(GET_CURRENT_CUSTOMER_GIFT_CARDS)
  const giftCards = data?.currentCustomer?.orderGiftCards ?? []

  return (
    <div className="user-profile-panel user-profile-panel_enter">
      <section className="user-profile-section">
        <h2 className="user-profile-section__title">Gift Cards</h2>
        <QueryState
          emptyLabel="No gift cards yet"
          error={error}
          isEmpty={(giftCards ?? []).length === 0}
          loading={loading}
        >
          <div className="user-profile-gift-grid">
            {giftCards.map((gc: GiftCard) => (
              <GiftCardTile key={gc.id} card={gc} />
            ))}
          </div>
        </QueryState>
      </section>
    </div>
  )
}
